/**
 * "Geometry settled" gate before the logo's last leg (KAN-562 landing fix).
 *
 * On a real iPhone the welcome's header can still move for a few frames after
 * the sheet mounts under the splash: the touch band (`--cvx-modal-*-reserve`)
 * is re-measured as the shell's safe-area padding settles, and the centered
 * panel follows it. Flying to a rect read in that window lands the logo where
 * the header WAS. So the splash holds (opaque) until the target's rect reads
 * the same on SPLASH_GLIDE_SETTLE_FRAMES consecutive frames — bounded by
 * SPLASH_GLIDE_SETTLE_MAX_MS, after which it flies anyway (logoJourney then
 * retargets in flight if the target still moves).
 */
export const SPLASH_GLIDE_SETTLE_FRAMES = 2;
export const SPLASH_GLIDE_SETTLE_MAX_MS = 250;
/** Sub-pixel noise is not movement. */
const EPS_PX = 0.5;

export function rectsMatch(a, b, eps = EPS_PX) {
  return Boolean(a && b)
    && Math.abs(a.left - b.left) <= eps && Math.abs(a.top - b.top) <= eps
    && Math.abs(a.width - b.width) <= eps && Math.abs(a.height - b.height) <= eps;
}

/**
 * Feed one rect per frame; returns true once it has held still for `frames`
 * consecutive frames, or `maxMs` after the first read — whichever comes first.
 */
export function createSettleGate({ frames = SPLASH_GLIDE_SETTLE_FRAMES, maxMs = SPLASH_GLIDE_SETTLE_MAX_MS } = {}) {
  let first = null;
  let last = null;
  let still = 0;
  return function step(rect, now) {
    if (first == null) first = now;
    still = last && rectsMatch(rect, last) ? still + 1 : 0;
    last = rect;
    return still >= frames || now - first >= maxMs;
  };
}
